<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" class="demo-form-inline" :model="searchForm" :ref="searchForm">
          <el-col>
            <el-form-item label="产品名称：">
              <el-input size="medium" placeholder="名称" minlength="2" maxlength="10" v-model="searchForm.NAME" clearable></el-input>
            </el-form-item>
            <el-button size="medium" type="primary" @click="handleCurrentChange(1)">筛选</el-button>
          </el-col>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" @click="openAdd">新增配置</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border style="margin-top: 20px" :data="tableData">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="DP_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="NAME" label="产品名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="openDetail(scope.row)" type="text">查看配料表</el-button>
              <el-button @click="deleteRecord(scope.row)" type="text" style="color: red">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount" style="float: right"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  productionSettingFun1, deleteFun1,
} from 'api/productionSet';

export default {
  data() {
    return {
      tableData: [],
      currentPage: 1,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      totalCount: 0,
      searchForm: {},
    };
  },
  created() {
    this.queryData();
    sessionStorage.removeItem('productArr');
  },
  computed: {
    SAVE_PRODOCTION_LIST() {
      return this.$store.state.PRODUCTION_LIST;
    },
  },
  methods: {
    queryData() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.NAME) {
        params.PRODUCT_NAME = this.searchForm.NAME;
      }
      if (this.searchForm.department) {
        params.DEPARTMENT_ID = this.searchForm.department;
      }
      productionSettingFun1(params).then((result) => {
        if (result[0]) {
          this.tableData = result[0].LIST;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    openAdd() {
      this.$router.push({ name: 'addDish' });
    },
    openDetail(row) {
      this.$router.push({ name: 'ingredientsDetail' });
      sessionStorage.setItem('PPL_ID', row.ID);
    },
    deleteRecord(row) {
      const params = {
        PPL_ID: row.ID,
      };
      deleteFun1(params).then((result) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.queryData(0);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/productionProcessing/dishManagement.vue